<template>

    <header class="primary-header">
      <div class="primary-header__container">
        
        <div class="app-logo-holder--mobile">
          <span class="sr-only">Advisgo</span>
            <product-logo />
        </div>

        <div class="app-logo-holder--desktop">
          <span class="sr-only">Advisgo</span>
            <product-icon-logo />
        </div>

        <button
          class="sidenav-trigger"
          v-on:click="navOpen=!navOpen" 
          v-bind:class="{active:navOpen}"
          aria-label="Navigation Button"
          >
          <span class="hb hb--top"></span>
          <span class="hb hb--mid"></span>
          <span class="hb hb--bottom"></span>
        </button>

      </div>
        
      <div 
        class="sidemenu-wrapper"
        :class="[navOpen ? 'nav-open' : 'nav-closed']"
        >
        <nav 
          class="primary-nav"
          style="height: 100%"
          >
          <ul class="primary-nav__list">

            <navigation-tab 
              v-for="route in allowedRoutes" 
              :key="route.name"
              @navOpen="val => { navOpen = val;}"
              :navOpen="navOpen"
              :route="route"
            />

            <li class="primary-nav__item">
              <a
                @click="openHelpPanel"
                @keyup.enter="openHelpPanel" 
                class="primary-nav__link"
                tabindex="0"
                >
                <v-icon
                  icon="$infoCircle"
                  class="primary-nav__icon"
                  />
                  <span class="primary-nav__text">{{ $t("navigation.help") }}</span>
                </a>
            </li>
            
            <li class="primary-nav__item" v-if="authStore.getIsLogoutEnabled">
              <a
                @click="logoutAction"
                class="primary-nav__link"
                tabindex="0"
                >
                <v-icon
                  icon="$logout"
                  class="primary-nav__icon"
                  />
                  <span class="primary-nav__text">{{ $t("navigation.logout") }}</span>
                </a>
            </li>
            
          </ul>
        </nav>
      </div>

      <div class="desktopnav-wrapper">

        <nav 
          class="primary-nav"
          >
          <ul class="primary-nav__list">

            <navigation-tab
              v-for="route in allowedRoutes"
              :key="route.name"
              :route="route"
              :screenReaderOnly="true"
            />
            <div class="bottom">
              <li class="primary-nav__item">
                <a
                  @click="openHelp($event)"
                  @keyup.enter="openHelp($event)" 
                  class="primary-nav__link"
                  tabindex="0"
                  >
                  <v-icon
                    icon="$infoCircle"
                    class="primary-nav__icon"
                    />
                    <span class="primary-nav__text sr-only">{{ $t("navigation.help") }}</span>
                    <v-tooltip
                      activator="parent"
                      location="start"
                      class="i-tooltip i-tooltip--left"
                      :title="$t('navigation.logout')"
                    >{{ $t("navigation.help") }}</v-tooltip>
                  </a>
              </li>
              <li class="primary-nav__item">
                <a
                  @click="openSettings($event)"
                  @keyup.enter="openSettings($event)" 
                  class="primary-nav__link"
                  tabindex="0"
                  >
                  <v-icon
                    icon="$cog"
                    class="primary-nav__icon"
                    />
                    <span class="primary-nav__text sr-only">{{ $t("navigation.settings") }}</span>
                    <v-tooltip
                      activator="parent"
                      location="start"
                      class="i-tooltip i-tooltip--left"
                      :title="$t('navigation.settings')"
                    >{{ $t("navigation.settings") }}</v-tooltip>
                  </a>
              </li>
              <li class="primary-nav__item" v-if="authStore.getIsLogoutEnabled">
                <a
                  @click="logoutAction"
                  @keyup.enter="logoutAction" 
                  class="primary-nav__link"
                  tabindex="0"
                  >
                  <v-icon
                    icon="$logout"
                    class="primary-nav__icon"
                    />
                    <span class="primary-nav__text sr-only">{{ $t("navigation.logout") }}</span>
                    <v-tooltip
                      activator="parent"
                      location="start"
                      class="i-tooltip i-tooltip--left"
                      :title="$t('navigation.logout')"
                    >{{ $t("navigation.logout") }}</v-tooltip>
                  </a>
              </li>
            </div>
          </ul>
        </nav>
      
      </div>

    </header>


</template>

<script lang="ts">
import ProductLogo from '@/components/shared/ProductLogoComponent.vue';
import ProductIconLogo from '@/components/shared/ProductIconLogoComponent.vue';
import { useAuthenticationStore } from '@/stores/authentication';
import NavigationTab from './NavigationTab.vue';

// import {sections} from '@/router';

export default {
  name: "primary-header",
  props: ["section"],
  components: {
      ProductLogo,
      ProductIconLogo,  
      NavigationTab
  },
  computed: {
    isRuntime() {
      return this.section[0].name.includes('runtime')
    },
    allowedRoutes() {
      return this.section.filter((route) => {
        // Hide routes marked as hideFromGenesys for Genesys users
        if (route.meta.hideFromGenesys && this.authStore.getIsGenesysUser) {
          return false;
        }
        
        // Standard group-based filtering
        return route.meta.groups == undefined
          || route.meta.groups == null
          || route.meta.groups.length == 0
          || route.meta.groups.filter(c => this.hasDirective(c)).length > 0;
      });
    }
  },
  methods: {
    hasDirective(directive: string) {
      return this.authStore.hasDirective(directive)
    },
    async logoutAction(event: Event) {
      try {
        this.authStore.logOut();
        this.$router.push({name: 'login'})
      } finally {
        // window.location.reload();
        
      }
      //this.$router.push({ path: '/login' });
      event.preventDefault()
    },
    openHelp(event: Event) {
      const opener = event.currentTarget as Element | null;
      this.$emit('openHelp', { opener });
    },
    openSettings(event: Event) {
      const opener = event.currentTarget as Element | null;
      this.$emit('openSettings', { opener });
    },
    returnFocus() {      
      const elem = document.getElementById("filterToggle");
      elem?.focus();
    },
  },
  data () {
    return {
      navOpen: false,
      userGroup: useAuthenticationStore().getUserGroup as string
    }
  },
  setup() {
    const authStore = useAuthenticationStore();

    return {
      authStore,
    }
  },
}
</script>

<style lang="scss">

$display-breakpoints: (
  'sm-and-down': 'only screen and (max-width: 959px)',
  'md-and-up': 'only screen and (min-width: 960px)',
  'lg': 'only screen and (min-width: 1264px)'
);

 .primary-header {
    position: fixed;
    display: flex;
    height: $navbar-ratio;
    top: $zero;
    right: $zero;
    z-index: 99;
    background-color: rgb(var(--v-theme-white));
    width: 100%;
    box-shadow: 0px 0px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 
                0px 4px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.04)), 
                0px 4px 10px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.04));
    &__container {
        align-items: center;
        display: flex;
        flex: 0 0 auto;
        position: relative;
        transition: inherit;
        width: 100%;
    }
}

.app-logo-holder {
    &--mobile {
        // display: block;
        display: flex;
        height: $product-logo-mob-height;
        width: auto;
        margin-left: $spacer10*2;
        padding-top: calc($spacer / 2);
    }
    &--desktop {
        display: none;
    }
}

.sidenav-trigger {
    position: absolute;
    display: block;
    width: $navbar-ratio;
    height: $navbar-ratio;
    background: rgb(var(--v-theme-white));
    border: none;
    z-index: 100;
    appearance: none;
    cursor: pointer;
    outline: none;
    top: $zero;
    right: $zero;   
    .hb {
        display: block;
        width: $hb-width;
        height: $hb-height;
        margin: auto;
        background: rgb(var(--v-theme-menu-base));
        position: absolute;
        top: $zero;
        bottom: $zero;
        left: $zero;
        right: $zero;
        transition: all .4s ease;
        &--top {
            transform: translateY(-$hb-translate);
        }
        &--bottom {
            transform: translateY($hb-translate);
        }
    }
    &:focus-visible {
        outline: 1px dashed rgb(var(--v-theme-menu-base));
    }
    &.active {
        background: rgb(var(--v-theme-menu-base));
        &:active
        &:focus-visible {
            outline: 1px dashed rgb(var(--v-theme-white));
        }
        .hb {
            background: rgb(var(--v-theme-white));
            &--top {
                transform: rotate(-45deg);
            }
            &--mid{
                transform: translateX(-20px) rotate(360deg);
                opacity: 0;
            }
            &--bottom {
                transform: rotate(45deg);
            }
        }
    }
}

.sidemenu-wrapper {
    position: fixed;
    background-color: rgb(var(--v-theme-menu-base));
    height: calc(100vh - $navbar-ratio);
    width: 100%;
    top: $navbar-ratio;
    overflow-y: auto;
    transition: all .4s ease;
    &.nav-open {
        animation: open-animation .6s forwards;
        opacity: 1;
    }    
    &.nav-closed {
        animation: close-animation .6s forwards;
        opacity: 0;
    }
}

.desktopnav-wrapper {
    display: none;
}

.primary-nav {
    &__list {
        height: 100%;
        padding-top: $spacer10*5;
        list-style:none;
        padding: 0;
        margin: 0;
    }
    &__item {
        border-bottom: 1px solid rgba(255, 255, 255, .1);
        margin-left: $spacer10;
        margin-right: $spacer10;
    }
    &__link {
        text-decoration: none;
        line-height: 2.2em;
        font-size: 1em;
        padding: .5em;
        display: block;
        color: rgb(var(--v-theme-white));
        transition: 1s ease;
        padding-left: $spacer10;
        padding-right: $spacer10;
        margin-left: -$spacer10;
        margin-right: -$spacer10;
        position: relative;
        cursor: pointer;
        &.nav-active {
            background: rgb(var(--v-theme-menu-state));
            color: rgb(var(--v-theme-white));
            &:hover {
                background: rgb(var(--v-theme-menu-state));
                color: rgb(var(--v-theme-white));
                cursor: default;
            }
        }
        &:hover {
            background-color: rgb(var(--v-theme-white));
            color: rgb(var(--v-theme-menu-base));
        }
        &:focus-within {
            background-color: rgb(var(--v-theme-white));
            color: rgb(var(--v-theme-menu-base));
            outline: 1px dashed rgb(var(--v-theme-menu-base));
        }
        
    }
    .v-icon {
        width: $navIcon;
        height: $navIcon;
        margin-left: $spacer10;
        margin-right: $spacer10;
        margin-top: -3px;
    }
}

.bottom {
    border-top: 1px solid rgba(255, 255, 255, .1);
    position: absolute;
    width: 100%;
    bottom: 0;
}


@media #{map-get($display-breakpoints, 'sm-and-down')} {
    @keyframes open-animation {
        from {
            transform: translateX(100%);
        }
        to {
            transform: translateX(0);
        }
    }
    
    @keyframes close-animation {
        from {
            transform: translateX(0);
        }
        to {
            transform: translateX(100%);
        }
    }
}
  

@media #{map-get($display-breakpoints, 'md-and-up')} {
    
    .sidenav-trigger {
        display: none;
    }
    .primary-header {
        background-color: rgb(var(--v-theme-menu-base));
        width: $navbar-ratio;
        height: 100vh;
        left: $zero;
        box-shadow: 4px 4px 4px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 
                4px 4px 5px 4px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.04)), 
                4px 4px 10px 4px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.04));
    }
    
    .app-logo-holder {       
        &--desktop {
            //display: block;
            height: $navbar-ratio;
            width: $navbar-ratio;
            display: flex;
            background-color: rgb(var(--v-theme-white));
            position: absolute;
            top: $zero;
            left: $zero;
            justify-content: center;
            align-items: center;
            svg {
                max-height: $navbar-logo-icon;
                max-width: $navbar-logo-icon;
            }
        }
        &--mobile {
            display: none;
        }
    }
    .desktopnav-wrapper {
        position: fixed;
        display: block!important;
        height: calc(100vh - $navbar-ratio);
        width: $navbar-ratio;
        top: $navbar-ratio;
    }
    .sidemenu-wrapper {
        display: none;
    }

    .primary-nav {
        &__item {
            margin-left: $resetSpace;
            margin-right: $resetSpace;
        }
        &__link {
            padding-left: unset;
            padding-right: unset;
            margin-left: unset;
            margin-right: unset;
            height: $navbar-ratio;
            &.nav-active {
                background: rgb(var(--v-theme-menu-state));
                color: rgb(var(--v-theme-white));
                &:hover {
                    background: rgb(var(--v-theme-menu-state));
                    color: rgb(var(--v-theme-white));
                    cursor: default;
                }
            }
            &:hover {
                background-color: rgb(var(--v-theme-white));
                color: rgb(var(--v-theme-menu-base));
            }
        }
        .v-icon {
            margin-left: $spacer10*2;
            margin-right: $spacer10;
            margin-top: $spacer10;
        }
    }
}
   
</style>
